import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import {
  Row,
  Col,
  Button,
  Table,
} from 'reactstrap';
import AddCampaign from './add-campaign';
import DeleteModal from './DeleteModal';
import CampaignList from './CampaignList';
import { getAgencies } from '../../actions/agency';

import details from './models';

class Admin extends React.PureComponent {
  componentDidMount() {
    getAgencies();
  }

  openAddCampaign = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'OPEN_ADD_CAMPAIGN' });
  };

  render() {
    return (
      <main className="p-5">
        <Row>
          <Col>
            <h2 className="mb-3 font-weight-bold">Campaign Management</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="border bg-white pt-5 h-100 shadow-sm">
              <Row className="mb-4">
                <Col className="d-flex">
                  <div className="ms-auto me-4">
                    <Button
                      className="text-white ms-2"
                      onClick={this.openAddCampaign}
                    >
                      <FontAwesomeIcon icon={faPlus} size="lg" className="me-2" />
                      Create Campaign
                    </Button>
                  </div>
                </Col>
              </Row>

              <Table size="sm" className="font-small mb-0">
                <thead className="bg-gray">
                  <tr>
                    {details.map((model) => (
                      <th className="p-2" key={model.id}>
                        {model.name}
                      </th>
                    ))}
                    <th> </th>
                  </tr>
                </thead>
                <CampaignList />

              </Table>
            </div>
          </Col>
        </Row>
        <AddCampaign />
        <DeleteModal />
      </main>
    );
  }
}

export default connect()(Admin);
